// extracted by mini-css-extract-plugin
export var container = "_ib-0";